// routerAdditives.util.ts
/*
    Functions in here get automatically synced through to routes as "addons" to the window property.
*/

import { db } from '../../config/main_config';
import { fetchIssueRegister } from './fetchIssueRegister.util'; // You can also import other utility functions here and export them as needed.
import { waitForCompanyID } from './waitForCompanyID.util'; // You can also import other utility functions here and export them as needed.
import { parseIssueRegisterRows } from './parseIssueRegisterRows.util'; // You can also import other utility functions here and export them as needed.
import { createModal } from './createModal.util'; // You can also import other utility functions here and export them as needed.
import { initialiseSelectorModal, loadSelectorModal } from '../ControlSelector/controlSelector.module';
import { addNewIssue } from './saveNewIssue.util'; // You can also import other utility functions here and export them as needed.
import { saveEditedIssue, getIssueData } from './editIssue.util';
import { createToast } from './createToast.util';
import { docsByRoute } from './docsByRoute.util';
import { parseDocsMSG } from './parseDocs.msg.util'; // For MSG only
import { findFrameworkName } from './findFrameworkName.util';
import { getInterestedParties, parseInterestedParties } from './getInterestedParties.util';
import { openModal } from './openModal.util';
import { closeModal } from './closeModal.util';
import { window } from './window.util';
import { getControlReferences } from './getControlReferences';
import { populateTooltips } from './populateTooltips.msg.util';
import { addNewInterestedParty } from './saveInterestedParties.util';
import { openEditInterestedPartyModal, saveEditedInterestedParty } from './editInterestedParty.util';
import { fetchScopeData, renderTableordion, updateScopeDescription, saveEditedDescription, initialiseScopeManager } from './scopeManager.util';
import { fetchLegalObligations, openEditLegalObligationModal, renderLegalObligationsTable, setupLegalObligationsListener, addLegalObligation, editLegalObligation, handleAddLegalObligation, handleEditLegalObligation, deleteLegalObligation } from './legalObligationsManager.util'
import { fetchISMSRoles, fetchRoles, fetchUsers, renderRolesTable, updateUserRoles, setupRolesListener, handleEditUserRoles } from './rolesManager.util';
import { initialiseISMSRoles } from './ismsRolesManager.util';
import { initialiseDocumentation, setupDocumentationListener } from './documentationManager.util';
import { fetchCommunications } from './communicationData.util';
import { exportMSG } from './msgExporter.util';
import { ContentFilters } from './ContentFilters.util';
import { SupportingDocs } from '../namespaces/SupportingDocs.namespace';
import { CollaborativeEditor } from './collaborativeEditor.util';
import { extractAssIDNumber } from './extractAssID.util';
import { generateMeetingAgenda } from './generateMeetingAgenda.util';
import { nameFromUID } from './nameFromUID.util';
import { MeetingAgenda } from '../classes/MeetingAgenda.class';
import { TableExporter } from './TableExporter.util';
// import { generateDocument as generateCorrectiveActions } from './correctiveActionGenerator.util';
import { fetchControls, renderControlsTable, setupControlsListener, saveControls as saveConfigControls, saveControlsWithProgressBar } from './ControlsManager.util';
import { CompanySettings } from '../../../classes/CompanySettings';
import { nameOrEmailToUID } from './nameOrEmailToUID.util';
import { AssetRegister } from '../namespaces/AssetRegister.namespace';
import { AssuranceLibrary } from '../namespaces/AssuranceLibrary.namespace';
import { RiskRegister } from '../namespaces/RiskRegister.namespace';
import { DocumentLibrary } from '../namespaces/DocumentLibrary.namespace';
import { PolicyLibrary } from '../namespaces/PolicyLibrary.namespace';
import { ControlLibrary } from '../namespaces/ControlLibrary.namespace';
import { LegalObligationLibrary } from '../namespaces/LegalObligationsLibrary.namespace';
import { MSRegister } from '../namespaces/MSRegister.namespace';
import { ObjectivesRegister } from '../namespaces/ObjectivesRegister.namespace';
import { isStandardEnabled } from './EnabledModulesManager';
import { waitForElement } from './waitForElement.util';
// window.waitForElement = waitForElement;

import { SearchBar } from '../classes/SearchBar.class';

import Swal from 'sweetalert2';
// Classes
import Tableordion from './tableordion.util'; // You can also import other classes here and export them as needed.
import { NotificationSystem } from '../namespaces/NotificationSystem/NotificationSystem.namespace';

import { fetchObjectives, renderObjectivesTable, setupObjectivesListener, addObjective, editObjective, deleteObjective, openEditObjectiveModal } from './objectivesManager.util';

import { setupSpecialInterestGroupsListener, renderSpecialInterestGroupsTable, addGroup, openEditGroupModal, editGroup, deleteGroup, handleAddGroup, handleEditGroup } from './specialInterestGroupsManager.util';
import { deiterateAPI } from './deiterateAPI.util';

// Utility function to get organization ID from SSR flags or fallback
function getOrganizationID(): string {
    return window._SSR_FLAGS?.OrganizationID || window.companyID;
}

// Initialize organization ID from SSR flags
if (window._SSR_FLAGS?.OrganizationID) {
    window.companyID = window._SSR_FLAGS.OrganizationID;
}

waitForCompanyID().then(async () => {
    // Check if settings are already available in SSR flags
    if (window._SSR_FLAGS?.additives?.companySettings) {
        window.additives = {
            companySettings: window._SSR_FLAGS.additives.companySettings
        };
    } else {
        // Fall back to loading from Firestore if not in SSR flags
        const settings = new CompanySettings(db, getOrganizationID());
        window.additives = {
            companySettings: await settings.loadSettings()
        };
    }
})

// Export the utility function
export { getOrganizationID };
/**
 * Handles the addition of a new objective.
 * 
 * @param event - The event triggered by the save button.
 */
/**
 * Handles the addition of a new objective.
 * 
 * @param event - The event triggered by the save button.
 */
async function handleAddObjective(event: Event): Promise<void> {
    event.preventDefault();

    // Retrieve input values
    const objectiveText = (document.querySelector('[data-managedid="AddObjectiveModal"] #objectiveText_add') as HTMLInputElement).value.trim();
    const objectiveTargetDate = (document.querySelector('[data-managedid="AddObjectiveModal"] #objectiveTargetDate_add') as HTMLInputElement).valueAsDate;
    const dateAddedElement = (document.querySelector('[data-managedid="AddObjectiveModal"] #dateAdded_add') as HTMLInputElement).valueAsDate;

    // Validate inputs
    if (!objectiveText || !objectiveTargetDate) {
        createToast({
            message: 'All fields are required.',
            customStyles: {
                backgroundColor: '#ffcc00',
                color: '#000000'
            }
        });
        return;
    }

    // Add the new objective
    await addObjective(objectiveText, objectiveTargetDate, dateAddedElement);

    // Close the modal
    handleModalClose(document.querySelector('[data-managedid="AddObjectiveModal"]') as HTMLElement);

    // Clear input fields
    (document.querySelector('[data-managedid="AddObjectiveModal"] #objectiveText_add') as HTMLInputElement).value = '';
    (document.querySelector('[data-managedid="AddObjectiveModal"] #objectiveTargetDate_add') as HTMLInputElement).value = '';
}
/**
 * Handles the editing of an existing objective.
 * 
 * @param event - The event triggered by the save button.
 */
async function handleEditObjective(event: Event): Promise<void> {
    event.preventDefault();

    const modal = document.querySelector('[data-managedid="EditObjectiveModal"]') as HTMLElement;
    const objectiveId = modal.getAttribute('data-id');

    if (!objectiveId) {
        console.error('Objective ID not found in the modal.');
        createToast({
            message: 'An error occurred. Please try again.',
            customStyles: {
                backgroundColor: '#ff0000',
                color: '#ffffff'
            }
        });
        return;
    }

    // Retrieve updated input values
    const objectiveText = (document.querySelector('[data-managedid="EditObjectiveModal"] #objectiveText_edit') as HTMLInputElement).value.trim();
    const objectiveTargetDate = (document.querySelector('[data-managedid="EditObjectiveModal"] #objectiveTargetDate_edit') as HTMLInputElement).valueAsDate;
    const objectiveDateAdded = (document.querySelector('[data-managedid="EditObjectiveModal"] #dateAdded_edit') as HTMLInputElement).valueAsDate;

    // Validate inputs
    if (!objectiveText || !objectiveTargetDate) {
        createToast({
            message: 'All fields are required.',
            customStyles: {
                backgroundColor: '#ffcc00',
                color: '#000000'
            }
        });
        return;
    }

    // Edit the objective
    await editObjective(objectiveId, objectiveText, objectiveTargetDate, objectiveDateAdded);

    // Close the modal
    closeModal(document.querySelector('[data-managedid="EditObjectiveModal"]') as HTMLElement);
}

/**
 * Updates the innerHTML of an element after a specified delay.
 * @param element - The HTMLElement to update.
 * @param innerHTML - The new innerHTML content.
 * @param delay - Optional delay in milliseconds before updating.
 */
function updateButtonState(element: HTMLElement, innerHTML: string, delay: number = 0): void {
    setTimeout(() => {
        element.innerHTML = innerHTML;
    }, delay);
}

/**
 * Applies default flex styles to an HTMLElement.
 * @param el - The HTMLElement to style.
 */
function applyStyles(el: HTMLElement): void {
    const style = el.style;
    style.display = style.display || 'flex';
    style.flexDirection = style.flexDirection || 'row';
    style.flexWrap = style.flexWrap || 'nowrap';
    style.alignContent = style.alignContent || 'center';
    style.justifyContent = style.justifyContent || 'center';
    style.alignItems = style.alignItems || 'center';
    style.gap = style.gap || '10px';
}

/**
 * Escapes HTML special characters in a string to prevent XSS attacks.
 * @param unsafe - The string to escape.
 * @returns The escaped string.
 */
function escapeHtml(unsafe: string): string {
    return unsafe
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

async function updatePageView(pageName: string, pathArray: string[], content: string | null): Promise<void> {
    if (content !== null) {
        const controlReferences = await getControlReferences(pageName, pathArray);
        if (!controlReferences) {
            console.error('Failed to retrieve control references.');
            return;
        }

        const contentArea = document.querySelector('.content-area');
        if (contentArea) {
            contentArea.innerHTML = populateTooltips(content, controlReferences);

        } else {
            console.error('Content area not found in the DOM.');
        }
    } else {
        console.error('No content provided');
    }
}

async function processContent(data: any, pathArray: string[]): Promise<string | null> {
    // Traverse the data using the keys in pathArray
    for (const key of pathArray) {
        if (data && Object.prototype.hasOwnProperty.call(data, key)) {
            data = data[key];
        } else {
            console.error(`Path not found: ${key}`);
            return null;
        }
    }

    // Retrieve the 'content' field at the end of the path
    if (data && Object.prototype.hasOwnProperty.call(data, 'content')) {
        return data['content'].replace(/\\r\\n|\\r|\\n/g, '<br>');
    } else {
        console.error('No content field at the end of the path');
        return null;
    }
}

/**
 * Fetches content from Firestore based on the page name and a path array.
 * @param pageName - The name of the page document.
 * @param pathArray - An array of keys to traverse the document data.
 * @returns A promise that resolves to the content string or null if not found.
 */
async function getContent(pageName: string, pathArray: string[], live: boolean = false): Promise<string | null | (() => void) | void> {
    try {
        // Fetch the document at the given resource path
        const docRef = db
            .collection('ManagementSystemGuide')
            .doc('defaults')
            .collection('pages')
            .doc(pageName);

        let data: any;

        if (!live) {
            const doc = await docRef.get();

            if (!doc.exists) {
                console.error('No such document!');
                return null;
            }

            data = doc.data();

            if (data) {
                let content = await processContent(data, pathArray);

                const contentFilters = new ContentFilters(null);

                if (window.customerLegalName) {
                    contentFilters.replacePlaceholder('Company Name', window.customerLegalName, content);
                    contentFilters.replaceWithRegex(/acme[\s,]*inc\.?/gi, window.customerLegalName, content);
                }

                return await updatePageView(pageName, pathArray, content);
            } else {
                console.error('Document data is null');
                return null;
            }
        } else {
            // Watch for changes in real-time
            return docRef.onSnapshot(async (doc) => {
                data = doc.data();

                if (data) {
                    let content = await processContent(data, pathArray);

                    const contentFilters = new ContentFilters(null);

                    if (window.customerLegalName) {
                        contentFilters.replacePlaceholder('Company Name', window.customerLegalName, content);
                        contentFilters.replaceWithRegex(/acme[\s,]*inc\.?/gi, window.customerLegalName, content);
                    }

                    return await updatePageView(pageName, pathArray, content);
                }
            });
        }
    } catch (error: any) {
        console.error('Error getting document:', error.message || error);
        return null;
    }
}

/**
 * Closes a modal by removing the 'show' class.
 * @param button - The button that triggered the close action. If null, attempts to close any open modal if 'anyModal' is true.
 * @param anyModal - If true and button is null, closes any open modal.
 */
function handleModalClose(button: HTMLElement | null = null, anyModal: boolean = false): void {
    // Find the closest modal that contains the button
    let modal: HTMLElement | null;
    if (button === null && anyModal) {
        modal = document.querySelector('.modal.show');
    } else if (button !== null) {
        modal = button.closest('.modal.show');
    } else {
        modal = null;
    }

    window.modalID = undefined;

    // If the modal is found, remove the 'show' class
    if (modal) {
        modal.classList.remove('show');
        modal.style.display = 'none';
    }

    // Also look for any .modal-backdrop and remove the show class from them
    const backdrops = document.querySelectorAll('.modal-backdrop.show');
    backdrops.forEach((backdrop) => {
        backdrop.classList.remove('show');
        (backdrop as HTMLElement).style.display = 'none';
    });
}

/**
 * Opens the 'Add New Issue' modal by adding the 'show' class.
 * @param button - The button that triggered the action (optional).
 */
function openNewIssueModal(button: HTMLElement | null = null): void {
    // If the modal is found, add the 'show' class
    const modal = (document.querySelector("[data-managedid='AddNewIssueModal']") as HTMLElement);
    window.modalID = modal.id;
    if (modal) {
        modal.classList.add('show');
        modal.style.display = 'block';
    }
}

/**
 * Opens the 'Edit Issue' modal and populates it with issue data.
 * @param button - The button that triggered the action.
 */
function openEditIssueModal(button: HTMLElement | null = null, oldIssue: boolean = false): void {
    // If the modal is found, add the 'show' class
    if (button === null) {
        console.log('Modal not triggered by a button.');
        return;
    }

    const issueID = button.dataset.issueid;
    if (!issueID) {
        console.error('No issue ID provided in the button data-issueID attribute');
        return;
    }

    const companyID = window?.companyID;
    if (!companyID) {
        console.error('Company ID not found on window object.');
        return;
    }

    getIssueData(companyID, issueID)
        .then((data) => {
            if (!data) {
                console.error('No data returned for the issue.');
                return;
            }
            console.log('Issue data:', data);

            const modalSelector = '[data-managedid="EditNewIssueModal"]';
            const modal = document.querySelector(modalSelector) as HTMLElement | null;
            window.modalID = modal.id;

            if (!modal) {
                console.error('Edit Issue Modal not found.');
                return;
            }

            const dateAddedInput = modal.querySelector('#dateAdded_edit') as HTMLInputElement | null;
            const descriptionInput = modal.querySelector('#description_edit') as HTMLInputElement | null;
            const issueTypeInput = modal.querySelector('#issueType_edit') as HTMLInputElement | null;
            const typeInput = modal.querySelector('#type_edit') as HTMLInputElement | null;
            const nameInput = modal.querySelector('#name_edit') as HTMLInputElement | null;
            const risksSelectedInput = modal.querySelector('#risksSelected_edit') as HTMLInputElement | null;
            const objectivesSelectedInput = modal.querySelector('#objectivesSelected_edit') as HTMLInputElement | null;
            const legalObligationsSelectedInput = modal.querySelector('#legalObligationsSelected_edit') as HTMLInputElement | null;
            const frameworksSelectedInput = modal.querySelector('#frameworksSelected_edit') as HTMLInputElement | null;

            if (dateAddedInput) dateAddedInput.value = data.dateAdded;
            if (descriptionInput) descriptionInput.value = data.description;
            if (issueTypeInput) issueTypeInput.value = data.details.issueType;
            if (typeInput) typeInput.value = data.type;
            if (nameInput) nameInput.value = data.name;
            if (risksSelectedInput) risksSelectedInput.value = data.details.risks.map(risk => (risk as any).riskID).join(', ');
            if (objectivesSelectedInput) objectivesSelectedInput.value = data.details.objectives.map(objective => (objective as any).id).join(', ');
            if (legalObligationsSelectedInput) legalObligationsSelectedInput.value = data.details.legalObligations.map(legalObligation => (legalObligation as any).id).join(', ');
            if (frameworksSelectedInput) frameworksSelectedInput.value = data.details.frameworks.map(control => (control as any).standard).join(', ')

            window.selectedRisks = data.details.risks;
            window.selectedISMSObjectives = data.details.objectives;
            window.selectedLegalObligations = data.details.legalObligations;
            window.selectedControls = data.details.frameworks;

            modal.classList.add('show');
            modal.style.display = 'block';
            modal.dataset.currentIssueId = issueID;
        })
        .catch((error: any) => {
            console.error('Error getting issue data:', error.message || error);
        });
}

// async function waitForWindowProperty(
//     propertyName: string,
//     callback?: Function,
//     failCallback: Function | null = null,
//     interval = 100,
//     timeout = 10000
// ): Promise<any> {
//     return new Promise((resolve, reject) => {
//         if (window[propertyName]) {
//             if (callback) {
//                 resolve(callback());
//             } else {
//                 resolve(window[propertyName]);
//             }
//         } else {
//             const startTime = Date.now();

//             const checkProperty = setInterval(() => {
//                 if (window[propertyName]) {
//                     clearInterval(checkProperty);
//                     if (callback) {
//                         resolve(callback());
//                     } else {
//                         resolve(window[propertyName]);
//                     }
//                 } else if (Date.now() - startTime > timeout) {
//                     clearInterval(checkProperty);
//                     console.warn(`${propertyName} was not available within the timeout period.`);
//                     if (failCallback !== null) {
//                         resolve(failCallback());
//                     } else {
//                         resolve(null);
//                     }
//                 }
//             }, interval);
//         }
//     });
// }


async function waitForWindowProperty(
    propertyName: string,
    callback?: Function,
    failCallback: Function | null = null,
    interval = 100,
    timeout = 10000
): Promise<any> {
    if (propertyName.includes(".")) {
        return waitForNestedWindowProperty(propertyName, callback, failCallback, interval, timeout);
    }

    return new Promise((resolve, reject) => {
        if (window[propertyName] !== undefined && window[propertyName] !== null) {
            if (callback) {
                resolve(callback());
            } else {
                resolve(window[propertyName]);
            }
        } else {
            const startTime = Date.now();

            const checkProperty = setInterval(() => {
                if (window[propertyName] !== undefined && window[propertyName] !== null) {
                    clearInterval(checkProperty);
                    if (callback) {
                        resolve(callback());
                    } else {
                        resolve(window[propertyName]);
                    }
                } else if (Date.now() - startTime > timeout) {
                    clearInterval(checkProperty);
                    console.warn(`${propertyName} was not available within the timeout period.`);
                    if (failCallback !== null) {
                        resolve(failCallback());
                    } else {
                        resolve(null);
                    }
                }
            }, interval);
        }
    });
}

async function waitForNestedWindowProperty(
    propertyPath: string,
    callback?: Function,
    failCallback: Function | null = null,
    interval = 100,
    timeout = 10000
): Promise<any> {
    return new Promise((resolve, reject) => {
        const getProperty = () => propertyPath.split('.').reduce((obj, key) => obj?.[key], window);

        if (getProperty() !== undefined && getProperty() !== null) {
            if (callback) {
                resolve(callback());
            } else {
                resolve(getProperty());
            }
        } else {
            const startTime = Date.now();

            const checkProperty = setInterval(() => {
                if (getProperty() !== undefined && getProperty() !== null) {
                    clearInterval(checkProperty);
                    if (callback) {
                        resolve(callback());
                    } else {
                        resolve(getProperty());
                    }
                } else if (Date.now() - startTime > timeout) {
                    clearInterval(checkProperty);
                    console.warn(`${propertyPath} was not available within the timeout period.`);
                    if (failCallback !== null) {
                        resolve(failCallback());
                    } else {
                        resolve(null);
                    }
                }
            }, interval);
        }
    });
}

// Export the functions (if needed)
export {
    updateButtonState,
    applyStyles,
    escapeHtml,
    getContent,
    fetchIssueRegister,
    waitForCompanyID,
    parseIssueRegisterRows,
    createModal,
    addNewIssue,
    handleModalClose,
    openNewIssueModal,
    openEditIssueModal,
    saveEditedIssue,
    getIssueData,
    createToast,
    docsByRoute,
    parseDocsMSG,
    findFrameworkName,
    getInterestedParties,
    parseInterestedParties,
    openModal,
    closeModal,
    getControlReferences,
    populateTooltips,
    addNewInterestedParty,
    openEditInterestedPartyModal,
    saveEditedInterestedParty,
    fetchScopeData,
    renderTableordion,
    updateScopeDescription,
    saveEditedDescription,
    initialiseScopeManager,
    fetchLegalObligations, renderLegalObligationsTable, setupLegalObligationsListener, addLegalObligation, editLegalObligation, handleAddLegalObligation, handleEditLegalObligation, deleteLegalObligation,
    fetchISMSRoles, fetchRoles, fetchUsers, renderRolesTable, updateUserRoles, setupRolesListener, handleEditUserRoles,
    waitForWindowProperty,
    handleAddObjective, handleEditObjective,
    fetchObjectives, renderObjectivesTable, setupObjectivesListener, addObjective, editObjective, deleteObjective,
    initialiseISMSRoles,
    initialiseDocumentation, setupDocumentationListener,
    fetchCommunications,
    exportMSG,
    initialiseSelectorModal, loadSelectorModal,
    openEditLegalObligationModal,
    openEditObjectiveModal,
    extractAssIDNumber,
    generateMeetingAgenda,
    nameFromUID,
    // generateCorrectiveActions,
    fetchControls, renderControlsTable, setupControlsListener, saveConfigControls, saveControlsWithProgressBar,
    nameOrEmailToUID
};

// Export Classes (if needed)
export { Tableordion, Swal, MeetingAgenda, TableExporter, SearchBar };

// Export namespaces (if needed)
export { SupportingDocs, CollaborativeEditor, NotificationSystem };

// Export Special Interest Groups Manager
export { setupSpecialInterestGroupsListener, renderSpecialInterestGroupsTable, addGroup, openEditGroupModal, editGroup, deleteGroup, handleAddGroup, handleEditGroup }
export { deiterateAPI }
export { AssetRegister, AssuranceLibrary, RiskRegister, DocumentLibrary, PolicyLibrary, ControlLibrary, LegalObligationLibrary, MSRegister, ObjectivesRegister }
export { isStandardEnabled }
export { waitForElement }